module.exports = __webpack_public_path__ + "img/1-11.eef89a5e.png";